import { render, staticRenderFns } from "./recallRecordList.vue?vue&type=template&id=c882015a"
import script from "./recallRecordList.vue?vue&type=script&lang=js"
export * from "./recallRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports